import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "302",
  "slug": "spot-vietnam-from-satellite-imagery",
  "title": "How to Recognise Vietnam in Satellite Images",
  "excerpt": "Vietnam has the Red River delta in the north, the Mekong delta in the south, and a narrower central coastal region backed by mountains.",
  "date": "2026-04-09",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/vietnam.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Vietnam has the Red River delta in the north, the Mekong delta in the south, and a narrower central coastal region backed by mountains. The long S-shaped mainland and the change in width between these regions are more useful than rice fields alone."
    },
    {
      "type": "heading",
      "text": "Two deltas beside a mountainous spine"
    },
    {
      "type": "paragraph",
      "text": "Compare the Mekong delta with the central coast. Notice how much farther the lowlands extend inland in the delta."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Cambodia shares the Mekong lowlands, while southern China shares some northern landscapes. A close crop of paddy fields can be ambiguous. Determine whether the surrounding terrain fits a delta or a narrow coast."
    }
  ],
  "imageAlt": "Vietnam regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
